import React, {useState} from 'react'
import {Typography, Grid} from '@material-ui/core'
import '../../styles/Reservation/Reservation.scss'
import SearchItem from './SearchItem'
import SelectedItems from './SelectedItems'
import ReservedForOptions from './CustomComponents/ReservedForOptions'

const StepSelectItem = ({showDate = false}) => {
  const [step, setStep] = useState(1)

  return (
    <>
      <section>
        <Typography className="ap-typography ap-typography--lg">Select Reserved For</Typography>
        <Grid container style={{marginTop: 0}}>
          <ReservedForOptions />
          {showDate && (
            <>
              <Grid item>
                <div className="ap-box">
                  <Typography className="ap-typography ap-typography--xs" style={{marginBottom: 4}}>
                    From
                  </Typography>
                  <Typography className="ap-typography ap-typography--sm">
                    03/15/2020 8:00 am
                  </Typography>
                </div>
              </Grid>
              <Grid item>
                <div className="ap-box">
                  <Typography className="ap-typography ap-typography--xs" style={{marginBottom: 4}}>
                    To
                  </Typography>
                  <Typography className="ap-typography ap-typography--sm">
                    04/12/2020 9:00 am
                  </Typography>
                </div>
              </Grid>
            </>
          )}
        </Grid>
      </section>
      <section style={{marginTop: 22}}>
        <Typography className="ap-typography ap-typography--lg">Select Items</Typography>
        <Grid container style={{marginTop: 0}} spacing={2}>
          <Grid item xs={10} style={{flex: 1}}>
            <SearchItem />
          </Grid>
          <Grid item style={{width: 192}}>
            <SelectedItems />
          </Grid>
        </Grid>
      </section>
    </>
  )
}

export default StepSelectItem
